// Legenda de uma mensagem de mídia.
//
// O backend grava o nome do arquivo salvo em Message.body quando a mídia vai sem
// legenda (`body: caption ? caption : filename` no verifyMediaMessage). Isso é
// inofensivo para exibir, mas não pode ser reaproveitado quando a legenda vira
// campo editável: abrir "Editar legenda" com "1782248202493.jpeg" preenchido
// gravaria o nome do arquivo como legenda de verdade no WhatsApp.
//
// Nota: difere do `corpoMensagem` do MessagesList, que para documento sem legenda
// exibe o nome ORIGINAL do arquivo. Ali é enfeite de tela; aqui seria salvo.

// Nome do arquivo salvo no servidor, a partir da URL pública da mídia
// (http://host/public/1782248202493.jpeg) — ou de um valor que já seja o nome.
// Aceita os dois porque Tickets.lastMessageMedia tem linhas antigas com a URL inteira
// no lugar do nome (ver DescreverMidiaTicket no backend).
export const nomeArquivo = (valor) => {
  if (!valor) return null;
  const bruto = String(valor).split("?")[0].split("/").pop();
  try {
    return decodeURIComponent(bruto);
  } catch (err) {
    return bruto;
  }
};

export const nomeArquivoSalvo = (message) => nomeArquivo(message?.mediaUrl);

// Legenda real da mídia — "" quando não tem legenda nenhuma. Em mensagem que não
// é mídia devolve o próprio body, então serve direto como "texto editável" da
// mensagem, seja legenda ou texto puro.
export const legendaMidia = (message) => {
  const corpo = message?.body || "";
  if (!message?.mediaUrl || !corpo) return corpo;
  return corpo.trim() === nomeArquivoSalvo(message) ? "" : corpo;
};
